import React, { useState, useEffect, useRef } from 'react';
import { vehicleSvgs } from "./sharedData";
import { useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, IconButton, Paper, Typography, Tooltip, List as MuiList, ListItem, ListItemText, TablePagination, TableContainer, Table, TableRow, TableHead, TableBody, TableCell, withStyles } from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import moment from 'moment'
import CustomSearch from './components/CustomSearch';
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import { useLocation } from 'react-router-dom';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import ShowTimePeriod from './components/ShowTimePeriod';
import ClearIcon from '@material-ui/icons/Clear';
import notify from './components/CustomUseNotify';
import "./css/ValetUsers.css";
import Skeleton from '@material-ui/lab/Skeleton';
import config from "./config.json"
import RightSideArrow from './images/rigit_side_arrow_svg.svg';
import CustomExportButton from './components/CustomExportButton';
import queryString from 'query-string';
import { saveTokens } from './utils/saveTokens';
import RightTickImg from './images/right_tick_img.svg'
import { AnalyticDistributionImgs } from "./sharedData";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ImageGalleryDialog from './components/ImageGalleryDialog';
import CustomFilter from './components/CustomFilter';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    timeFilterContainer: {
        alignItems: "center",
        marginTop: customTheme.spacing(5),
    },
    timeFilterInput: {
        marginLeft: "2%",
    },
    outlinedInput: {
        padding: 0,
    },
    timeFilterButton: {
        marginLeft: "1%",
        width: "10%",
        minWidth: 85
    },
    summaryListRoot: {
        marginTop: customTheme.spacing(2),
    },
    summaryCardContainer: {
        display: "grid",
        gridAutoFlow: "column",
        marginTop: customTheme.spacing(3),
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center",
    },
    listActions: {
        justifyContent: "space-between",
        marginTop: customTheme.spacing(3),
    },
    mainTableCell: {
        color: `${customTheme.palette.grey[900]} !important`,
        fontWeight: 500,
    },
    listVehicleIcon: {
        width: 25,
        height: 25,
        marginRight: customTheme.spacing(1),
        verticalAlign: "middle",
    },
    showLayoutMain: {
        marginTop: 0,
    },
    showTitle: {
        fontSize: 22,
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    removeMargin: {
        margin: 0,
    },
    parkingListHead: {
        color: customTheme.palette.grey[500],
    },
    inlineForm: {
        display: "grid",
        gridAutoFlow: "column",
        padding: "18px 2%",
        marginLeft: 15
    },
    removeUnderline: {
        borderBottom: "none",
    },
    checkIconButton: {
        borderRadius: 4,
        padding: "5px 5px 2px",
        '&:hover': {
            backgroundColor: "#0001 !important",
            cursor: "pointer",
        },
    },
    smallSelectRoot: {
        padding: "10px 32px 10px 18px",
    },
    receiptTextContainer: {
        display: "flex",
        padding: "15px 20px",
        '&:hover': {
            backgroundColor: "#00336608",
        },
        alignItems: "center",
        marginBottom: 15,
        border: "1px solid #bfbfbf",
        borderRadius: 4,
    },
    selectWithIcon: {
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: 20,
        paddingRight: "40px !important",
        columnGap: 30,
    },
    editSummaryTime: {
        color: "#888",
        fontSize: 20,
        marginLeft: 10,
        '&:hover': {
            cursor: "pointer",
            opacity: 0.7,
        }
    },
    backDrop: {
        backgroundColor: "#00000042"
    },
    statusCircle: {
        width: 7,
        height: 7,
        borderRadius: 10,
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    timeRangeButton: {
        flex: 1,
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#eee"
        }
    },
    title: {
        fontSize: 13,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 28,
        color: customTheme.palette.primary.main,
        fontWeight: customTheme.typography.fontWeightMedium
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    summaryVehicleIcon: {
        width: 18
    },
    summaryBoxLabel1: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    paymentSummaryBoxLabel1: {
        fontSize: 12,
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 12,
        color: "#334D6E",
        fontWeight: customTheme.typography.fontWeightMedium
    },
    tooltip: {
        fontSize: 9,
        fontFamily: "Poppins-Regular",
        fontWeight: "normal"
    }
});

const StyledTableCell = withStyles((theme) => ({
    root: {
        fontSize: 13,
        borderBottomColor: customTheme.palette.divider,
        padding: "15px 5px !important",
    },
    head: {
        fontWeight: 500,
        color: customTheme.palette.grey[700],
    },
    body: {
        fontWeight: 400,
        color: "#707683",
    },
}))(TableCell);

const ShiftDetailsSkeleton1 = props => <Skeleton variant="text" height={18} width={160} style={{ display: "inline-block", transform: "none" }} {...props} />;

const progressBarColor = ["#16CC69", "#5E8DD3", "#334D6E", "#F7685B", "#16CC69", "#5E8DD3", "#334D6E", "#F7685B"]

const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 4 }} alt={row.vehicle_type_label} />
        </div>
        :
        null
);

let gracePeriodInitState = {
    "data": {
        "Total Vehicles": {
            "totalSum": 1
        },
        "Grace Period Compliant (%)": {
            "totalSum": 1
        },
        "Grace Period Expired": {
            "totalSum": 1
        },
        "Live Vehicles Inside": {
            "totalSum": 1
        },

    },
    "loading": true,
    "isInitState": true
}

const createFiltersString = (settingFilterFormat, search, searchTypes, startDateTime, endDateTime, currentParking, role, userId) => {
    const filters = []

    if (search && searchTypes && searchTypes === 'Vehicle Number') filters.push(`vehicle_number:like:${search}`)
        if (startDateTime && endDateTime) filters.push(`created_at:between:${moment(startDateTime).format("YYYY-MM-DD HH-mm-ss")}~${moment(endDateTime).format("YYYY-MM-DD HH-mm-ss")}`)
        if (settingFilterFormat) {
            if (settingFilterFormat.vehicle_type) filters.push(`commuterVehicle.vehicle_type:equals:${settingFilterFormat.vehicle_type}`)
            if (settingFilterFormat.current_status === 'Within Grace') filters.push(`is_expired:equals:0`)
            if (settingFilterFormat.current_status === 'Expired') filters.push(`is_expired:equals:1`)
            if (settingFilterFormat.duration) {
                const durationRange = settingFilterFormat.duration.split("-");
                filters.push(`total_duration:lt:${(durationRange[1] * 3600)}`)
                filters.push(`total_duration:gt:${(durationRange[0] * 3600)}`)
            }
            if (settingFilterFormat.starting_zone) {
                filters.push(`entryParkingDeviceId.gate_id:=:${settingFilterFormat.starting_zone}`)
                filters.push(`gracePeriodLogs.action:=:GRACE_PERIOD_ENTRY`)
            }
            if (settingFilterFormat.ending_zone) {
                filters.push(`exitParkingDeviceId.gate_id:=:${settingFilterFormat.ending_zone}`)
                filters.push(`gracePeriodLogs.action:=:GRACE_PERIOD_EXIT`)
            }
        }
        if(currentParking && currentParking.id) filters.push(`accessKey.id:equals:${currentParking.id}`)
        if(currentParking && currentParking.parking_info_id) filters.push(`accessKey.parking_info_id:equals:${currentParking.parking_info_id}`)

        if(role === 'contractor' && userId) filters.push(`accessKey.contractor_ids:fis:${userId}`)
        if(role === 'sales' && userId) filters.push(`accessKey.sales_ids:fis:${userId}`)

    return filters[0] ? filters.join(",") : null
}

export const GracePeriodLogs = (props) => {
    const classes = useStyles()
    const listDataRef = useRef();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [role] = useState(sessionStorage.getItem("role"));
    const [userId] = useState(sessionStorage.getItem("user_id"));
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [displayModal, setDisplayModal] = useState(false);
    const [gracePeriodDetails, setGracePeriodDetails] = useState(null)
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");

    const [showTiles, setShowTiles] = useState(true)
    const [gracePeriodSummary, setGracePeriodSummary] = useState(gracePeriodInitState)
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const [gracePeriodTableData, setGracePeriodTableData] = useState([])
    const [gracePeriodTableDataLoader, setGracePeriodTableDataLoader] = useState(false)
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDataLength, setTotalDataLength] = useState(0)
    const abortGracePeriodSummaryRequest = useRef(null);
    const abortGracePeriodLogsRequest = useRef(null);
    const [sortOrder, setSortOrder] = useState("DESC");
    const [sortBy, setSortBy] = useState("id")

    const filtersString = createFiltersString(settingFilterFormat, search, searchTypes, startDateTime, endDateTime, currentParking, role, userId)

    // const filter = { ...settingFilterFormat, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    let filterTypesInitState = [
        {
            filterType: "Vehicle Type",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Current Status",
            dataList: [{ name: "Within Grace", id: 1 }, { name: "Expired", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
			resourcePath: "parkingDevices",
			filterType: "Stating Zone",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "CON-ENTRY"
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
		},
		{
			resourcePath: "parkingDevices",
			filterType: "Ending Zone",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "CON-EXIT",
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
		},
        {
            filterType: "Duration",
            dataList: [],
            listType: "Static",
            caseType: "Static",
            filterFormat: "Range",
            showFilter: true
        },
    ]

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    const handleRequestSort = (property) => {
		const isAsc = sortBy === property && sortOrder === 'ASC';
		let tempOrder = isAsc ? 'DESC' : 'ASC';
		setSortOrder(tempOrder);
		setSortBy(property);
	};

    const getExportFile = (fileType) => {
        const params = {
            limit: rowsPerPage,
            page: page,
            ordering: sortOrder === "ASC" ? sortBy : `-${sortBy}`,
            filters: filtersString
        }
        fetch(`${config.HOST_NAME}/dashboard/v1/grace-period/sessions/download?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `grace_period_logs.csv`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const getGracePeriodSummary = () => {
        if (abortGracePeriodSummaryRequest.current) abortGracePeriodSummaryRequest.current.abort()
            abortGracePeriodSummaryRequest.current = new AbortController();

        const params = {
            filters: filtersString
        }

        setGracePeriodSummary({ loading: true, data: gracePeriodInitState.data, isInitState: true })
        fetch(`${config.HOST_NAME}/dashboard/v1/grace-period/sessions/tiles?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            signal: abortGracePeriodSummaryRequest.current.signal,
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setGracePeriodSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                if (e.name === "AbortError") console.log(e);
                else notify('Error Fetching Summary', 'warning')
            });
    }

    const getGracePeriodTableDetails = () => {
        if (abortGracePeriodLogsRequest.current) abortGracePeriodLogsRequest.current.abort()
            abortGracePeriodLogsRequest.current = new AbortController();

        const params = {
            limit: rowsPerPage,
            page: page,
            ordering: sortOrder === "ASC" ? sortBy : `-${sortBy}`,
            filters: filtersString
        }

        setGracePeriodTableDataLoader(true)
        fetch(`${config.HOST_NAME}/dashboard/v1/grace-period/sessions?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            signal: abortGracePeriodLogsRequest.current.signal,
        }).then(response => {
            saveTokens(response)
            return response.json()
        }).then(responseJson => {
            if (responseJson.success) {
                const data = responseJson.data
                if (data.results && data.results) {
                    setGracePeriodTableData(data.results);
                }
                setTotalDataLength(data.totalLength);
            }
            else notify(responseJson.message, 'warning');
        })
            .catch((e) => {
                if (e.name === "AbortError") console.log(e);
                else notify('Error Fetching Logs', 'warning')
            }).finally(() => {
                setGracePeriodTableDataLoader(false)
            })
    }

    useEffect(() => {
        getGracePeriodSummary()
    }, [currentParking, startDateTime, endDateTime, search, settingFilterFormat]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getGracePeriodTableDetails()
    }, [page, rowsPerPage, currentParking, startDateTime, endDateTime, search, settingFilterFormat, sortOrder]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let values = {}
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Vehicle Type") values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                if (filterListValue[val].filterType === "Current Status") values = { ...values, current_status: filterListValue[val].value ? filterListValue[val].value : undefined }
                if (filterListValue[val].filterType === "Starting Zone") values = { ...values, starting_zone: filterListValue[val].value ? filterListValue[val].value : undefined }
                if (filterListValue[val].filterType === "Ending Zone") values = { ...values, ending_zone: filterListValue[val].value ? filterListValue[val].value : undefined }
                if (filterListValue[val].filterType === "Duration") values = { ...values, duration: filterListValue[val].value ? filterListValue[val].value : undefined }

            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) setSettingFilterFormat({})
    }, [filterListValue])

    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} />
                <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} />
                <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
            </div>
            <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} showTiles={showTiles} setShowTiles={setShowTiles} />

            {showTiles &&
                <>
                    {/* <div className='secondaryColor fontWeightSemiBold' style={{ fontSize: 14, marginTop: 10 }}>All Analysis</div> */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                        {
                            Object.keys(gracePeriodSummary.data).map((value) => (
                                <SummaryCard
                                    title={value}
                                    data={gracePeriodSummary.data[value]["types"]}
                                    getValue={data => gracePeriodSummary.data[value]["totalSum"]}
                                    getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["label"])}
                                    getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                    getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["img"])}
                                    getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                    getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                        return { percentage: data[val].percentage ? data[val].percentage.toFixed(2) : 0, color: progressBarColor[i] }
                                    })}
                                    loading={gracePeriodSummary.loading}
                                    showDonutChart={false}
                                    showProgressBar={false}
                                />
                            ))
                        }
                    </div>
                </>
            }
            {!gracePeriodTableDataLoader && !gracePeriodTableData[0] ?
                <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px" }}>
                    <div style={{ color: "#334D6E", fontSize: 13, fontFamily: "Poppins-Medium" }}>No data found.</div>
                </Paper>
                : <>
                    {isSmallDevice &&
                        <MuiList>
                            {gracePeriodTableData.map((row, index) => {
                                return (<ListItem alignItems="flex-start" style={{ paddingLeft: 10, paddingRight: 10, borderBottom: "1px solid #18cc69" }}>
                                    <ListItemText
                                        primary={row.vehicle_type ? renderVehicleType(row) : null}
                                        secondary={<div>
                                            {row.vehicle_number && <div><span style={{ color: "#5a5a5a" }}>Vehicle No: </span>{row.vehicle_number}</div>}
                                            {row.current_status && <div><span style={{ color: "#5a5a5a" }}>Current Status: </span>{row.current_status}</div>}
                                            {row.entry_zone && <div><span style={{ color: "#5a5a5a" }}>Starting Zone: </span>{row.entry_zone}</div>}
                                            {row.entry_time && <div><span style={{ color: "#5a5a5a" }}>Start Time: </span>{row.entry_time}</div>}
                                            {row.exit_zone && <div><span style={{ color: "#5a5a5a" }}>Ending Zone: </span>{row.exit_zone}</div>}
                                            {row.exit_time && <div><span style={{ color: "#5a5a5a" }}>End Time: </span>{row.exit_time}</div>}
                                            {row.total_duration && <div><span style={{ color: "#5a5a5a" }}>Total Duration: </span>{row.total_duration}</div>}
                                            {row.is_penalty && <div><span style={{ color: "#5a5a5a" }}>Penalty: </span>{row.is_penalty ? "Yes" : "No"}</div>}
                                        </div>}
                                    />
                                </ListItem>)
                            })}
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100]}
                                count={totalDataLength}
                                rowsPerPage={rowsPerPage}
                                page={page - 1}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </MuiList>
                    }

                    {!isSmallDevice &&
                        <Paper style={{ width: "100%", boxShadow: "0px 4px 15px #0000001a", marginTop: "15px" }}>
                            <TableContainer component={ScrollableTable} style={{ boxShadow: "none" }}>
                                <Table size="small" style={{ padding: 0 }}>
                                    <TableHead style={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>
                                        <TableRow>
                                            <StyledTableCell>Type</StyledTableCell>
                                            <StyledTableCell>Vehicle No.</StyledTableCell>
                                            <StyledTableCell>Current Status</StyledTableCell>
                                            <StyledTableCell>Starting Zone</StyledTableCell>
                                            <StyledTableCell>
                                                <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => handleRequestSort("start_time")}>
                                                    <div>Start Time</div>
                                                    <div style={{ marginTop: 5 }}>{sortBy === "start_time" && sortOrder === "ASC" && <ArrowUpwardIcon style={{ fontSize: 15 }} />} {sortBy === "start_time" && sortOrder === "DESC" && <ArrowDownwardIcon style={{ fontSize: 15 }} />}</div>
                                                </div>
                                            </StyledTableCell>
                                            <StyledTableCell>Ending Zone</StyledTableCell>
                                            <StyledTableCell>
                                                <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => handleRequestSort("end_time")}>
                                                    <div>End Time</div>
                                                    <div style={{ marginTop: 5 }}>{sortBy === "end_time" && sortOrder === "ASC" && <ArrowUpwardIcon style={{ fontSize: 15 }} />} {sortBy === "end_time" && sortOrder === "DESC" && <ArrowDownwardIcon style={{ fontSize: 15 }} />}</div>
                                                </div>
                                            </StyledTableCell>
                                            <StyledTableCell>Total Duration</StyledTableCell>
                                            <StyledTableCell>Penalty Triggered</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className='vehicleSummaryFieldDataGrid'>
                                        {gracePeriodTableData && gracePeriodTableData[0] ?
                                            gracePeriodTableData.map((row, index) => (<TableRow style={{height: "45px"}} key={row["id"]}>
                                                <StyledTableCell>{row.vehicle_type ? renderVehicleType(row) : "-"}</StyledTableCell>
                                                <StyledTableCell>{row.vehicle_number ? row.vehicle_number : "-"}</StyledTableCell>
                                                <StyledTableCell>{row.current_status ? <div style={{display:"flex", justifyContent:'center'}}><div style={{display:"inline-flex", fontSize:"12px", padding:"1px 8px", borderRadius:"5px", color: row.current_status === 'Within Grace' ? "#18CC69" : "#F74E3D", backgroundColor: row.current_status === 'Within Grace' ?  "#18CC6919" : "#F74E3D19"}}>{row.current_status}</div></div> : "-"}</StyledTableCell>
                                                <StyledTableCell>{row.entry_zone ? row.entry_zone : '-'}</StyledTableCell>
                                                <StyledTableCell>{row.entry_time ? row.entry_time : '-'}</StyledTableCell>
                                                <StyledTableCell>{row.exit_zone ? row.exit_zone : '-'}</StyledTableCell>
                                                <StyledTableCell>{row.exit_time ? row.exit_time : '-'}</StyledTableCell>
                                                <StyledTableCell>{row.total_duration ? row.total_duration : '-'}</StyledTableCell>
                                                <StyledTableCell>{row.is_penalty ? "Yes" : "No"}</StyledTableCell>
                                                <StyledTableCell className='ListIconsContainerVehicleSummaryFieldData'>
                                                    <div className="ListIcons" style={{cursor:"pointer"}} onClick={() => {
                                                        setGracePeriodDetails(row)
                                                        setDisplayModal(true)
                                                    }}>
                                                        <div style={{ color: "#18CC69", fontSize: 12, marginRight: "6px" }}>View Journey</div>
                                                        <img src={RightSideArrow} alt='Arrow' width={14} height={14} />
                                                    </div>
                                                </StyledTableCell>
                                            </TableRow>))
                                            :
                                            [1, 2, 3].map((row) => (<TableRow key={row}>
                                                <StyledTableCell component="th" scope="row" className={classes.mainTableCell}><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                                <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                                <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                                <StyledTableCell><ShiftDetailsSkeleton1 width={100} /></StyledTableCell>
                                            </TableRow>))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                count={totalDataLength}
                                rowsPerPage={rowsPerPage}
                                page={page - 1}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Paper>
                    }
                </>
            }

            {displayModal && <CustomModal displayModal={displayModal} setDisplayModal={setDisplayModal} gracePeriodDetails={gracePeriodDetails} />}
        </div>
    )
};

const CustomModal = ({ displayModal, setDisplayModal, gracePeriodDetails }) => {
    const { id } = gracePeriodDetails
    const [loading, setLoading] = useState(false);
    const [gracePeriodLogs, setGracePeriodLogs] = useState(null)

    const fetchData = async () => {
        if (!id) return notify("ID required", "warning")
        resetStates()
        setLoading(true);
        try {
            const logsResponse = await fetch(`${config.HOST_NAME}/dashboard/v1/grace-period/sessions/${id}/logs`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    }
                }
            );
            const logs = await logsResponse.json();
            if (!logs.data[0]) return
            setGracePeriodLogs(logs.data)

        } catch (error) {
            console.log(error)
            notify('Something went wrong', "warning");
        } finally {
            setLoading(false);
        }
    };

    const resetStates = () => {
        setGracePeriodLogs(null)
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='valet_styles'>
            <div className={`CustomPopup ${displayModal ? "Show" : ""}`}>
                <div style={{ padding: "18px 18px" }}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", }}>
                        <div className='fontWeightSemiBold' style={{ flex: 1, color: "#334d6e", fontSize: 16 }}>
                            Grace Period Logs
                        </div>
                        <IconButton style={{ width: 25, height: 25 }} onClick={() => setDisplayModal(!displayModal)}>
                            <ClearIcon style={{ fontSize: 20 }} />
                        </IconButton>
                    </div>
                    {!loading && gracePeriodLogs && gracePeriodLogs[0] &&
                        <div style={{ marginTop: "16px", borderRadius: "8px", padding: "16px" }}>
                            {
                                gracePeriodLogs.map((gracePeriodLog, i) => {
                                    return <div key={i} style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                            <div className='valet_circle' style={{ backgroundColor: gracePeriodLog.activity_performed ? "#24A147" : "#DCDCDC" }}>
                                                {gracePeriodLog.activity_performed
                                                    ? <img src={RightTickImg} alt='Right Tick' width={15} height={12} />
                                                    : <div className='fontWeightRegular' style={{ color: "#7C7C7C", fontSize: "14px" }}>{i + 1}</div>
                                                }
                                            </div>
                                            {gracePeriodLogs.length !== i + 1 && <div className='valet_vertical_line'></div>}
                                        </div>
                                        <div style={{ flex: 1, display: "flex", justifyContent: "flex-start", alignItems: "flex-start", marginLeft: "8px", marginTop: !gracePeriodLog.activity_performed ? "5px" : "0px", }}>
                                            <div style={{ flex: 1 }}>
                                                <div className='fontWeightSemiBold' style={{ color: "#192A3E", fontSize: "14px" }}>{gracePeriodLog.title}</div>
                                                {gracePeriodLog.date && <div className='fontWeightSemiBold' style={{ color: "#7C7C7C", fontSize: "11px" }}>{gracePeriodLog.date}</div>}
                                            </div>

                                            {gracePeriodLog.imageUrl && <ImageGalleryDialog thumbnail={true} record={[gracePeriodLog.imageUrl]} getImages={(record) => [gracePeriodLog.imageUrl]} />}
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    }
                    {loading && !gracePeriodLogs && <LoadingActivities />}
                    {!loading && !gracePeriodLogs && <div className='fontWeightSemiBold' style={{ color: "#192A3E", fontSize: "14px", marginTop: "16px", borderRadius: "8px", padding: "16px" }}>Journey has not been started yet.</div>}
                </div>
            </div>
            <div
                className={`CustomOverlay ${displayModal ? "Show" : ""}`}
                onClick={() => setDisplayModal(!displayModal)}
            />
        </div>
    )
};

const LoadingActivities = () => {
    return (
        <div style={{ marginTop: "16px", borderRadius: "8px", border: "1px solid #EFEFEF", padding: "16px" }}>
            {
                [1, 2, 3, 4].map((i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start" }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                            <div className='valet_circle' style={{ backgroundColor: "#DCDCDC" }}>
                                <div className='fontWeightRegular' style={{ color: "#7C7C7C", fontSize: "14px" }}>{i}</div>

                            </div>
                            <div className='valet_vertical_line'></div>
                        </div>
                        <div style={{ marginLeft: "8px", marginTop: "5px" }}>
                            <Skeleton variant="text" height={22} width="200px" />
                            <Skeleton variant="text" height={22} width="150px" />
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

function SummaryCard({ title, loading, data, getValue, getDistributedValues, getDistributedLabels, getDistributedIcons, getDistributedPercentage, getDistributedValuePercentage, getSubPercentage, getDistributedAmount, showDonutChart, clickable, showProgressBar = false, getDistributedCount, showTooltip = false, getNestedTypes = null, isPaymentType = true, style }) {
    const classes = useStyles();

    return <Paper style={{ position: "relative", display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", cursor: clickable ? "pointer" : "", ...style }}>
        <div style={{ flex: 1 }}>
            <div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography className={classes.title} style={{ textTransform: "capitalize" }}>{title}</Typography>
                </div>
                {
                    !loading && data ?
                        <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                            {getDistributedCount && getDistributedCount(data) && <Typography className={classes.mainValue} style={{ color: "#334D6E", marginRight: 10 }}>{getDistributedCount(data)}</Typography>}
                            <Typography className={classes.mainValue}>{getValue(data)}</Typography>
                            {getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) &&
                                <div style={{ display: "flex", alignItems: "center", backgroundColor: "#18CC6919", fontSize: 9, color: "#18CC69", padding: "0px 10px", height: 15, borderRadius: 10, fontFamily: "Poppins-SemiBold" }}>
                                    {getSubPercentage(data)}%
                                </div>
                            }
                        </div>
                        :
                        !loading && !data ?
                            <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                                <Typography className={classes.mainValue}>{getValue(data) ? getValue(data) : 0}</Typography>
                            </div>
                            :
                            <Skeleton variant="text" height={42} width="50px" />
                }
            </div>
            {
                !loading && data ? getDistributedLabels(data).map((dL, i) => (
                    <div>
                        <div key={dL} className={classes.flexContainer}>
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <img className={classes.summaryVehicleIcon} src={getDistributedIcons(data)[i]} alt={dL} />
                                <Typography className={classes.summaryBoxLabel1}>{dL}:</Typography>
                            </div>
                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                <Typography className={classes.summaryBoxValue1}>{getDistributedValues(data)[i]}</Typography>

                                {isPaymentType && getDistributedAmount && getDistributedAmount(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>₹ {getDistributedAmount(data)[i].toFixed(2)}</Typography>                            </>
                                }
                                {!["Manual"].includes(dL) && getDistributedValuePercentage && getDistributedValuePercentage(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getDistributedValuePercentage(data)[i].toFixed(2)}%</Typography>
                                    {showTooltip && <Tooltip arrow title={`This percentage is the overall share for this gate for ${dL}`} classes={{ tooltip: classes.tooltip }}><InfoOutlinedIcon style={{ fontSize: 12, color: "#888" }} /></Tooltip>}
                                </>
                                }
                            </div>
                        </div>

                        {getNestedTypes && getNestedTypes(data) !== null &&
                            [Object.keys(getNestedTypes(data))[i]].map((val) => (
                                <>
                                    {getNestedTypes(data)[val]["types"] && Object.keys(getNestedTypes(data)[val]["types"]).map((subType) => (
                                        <div key={subType} className={classes.flexContainer} style={{ marginLeft: 20 }}>
                                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                                <img className={classes.summaryVehicleIcon} src={AnalyticDistributionImgs[subType]?.["img"]} alt={subType} />
                                                <Typography className={classes.summaryBoxLabel1}>{subType}:</Typography>
                                            </div>
                                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                                <Typography className={classes.summaryBoxValue1}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["count"] ? `${getNestedTypes(data)[val]["types"][subType]["count"]}` : '0'} </Typography>
                                                {isPaymentType && <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["amount"] ? `₹ ${getNestedTypes(data)[val]["types"][subType]["amount"].toFixed(2)}` : '₹ 0'} </Typography>}
                                                <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["percentage"] ? getNestedTypes(data)[val]["types"][subType]["percentage"].toFixed(2) : '0'}%</Typography>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ))
                        }


                    </div>
                )) :
                    !loading && !data ? null
                        :
                        ["50", "40"].map((width, index) => (
                            <Skeleton variant="text" width={width} height={18} key={index} />
                        ))
            }
        </div>

        {showProgressBar && data && getDistributedPercentage &&
            <div className="horizontal-bar" style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
                {getDistributedPercentage(data).map((item, index) => (
                    <Tooltip arrow title={`${item.percentage}%`} classes={{ tooltip: classes.tooltip }}>
                        <div key={index} className="bar-segment" style={{ width: `${item.percentage}%`, backgroundColor: item.color }}>
                        </div>
                    </Tooltip>
                ))}
            </div>
        }
    </Paper>

}